<tyl-button style="display: flex;"
    *ngIf="!useLink && !disabled"
    [image]="image"
    [label]="label"
    [showLabel]="showLabel"
    [iconWidth]="iconWidth"
    yPosition="below"
    #actionMenuTrigger
    [matMenuTriggerFor]="actionMenu"
    (click)="$event.stopPropagation()">
</tyl-button>

<tyl-button *ngIf="!useLink && disabled"
    style="display: flex;"
    (click)="$event.stopPropagation()"
    yPosition="below"
    [label]="label"
    [showLabel]="showLabel"
    [iconWidth]="iconWidth"
    [image]="image"
    [disabledImage]="disabledImage"
    [disabled]="disabled">
</tyl-button>

<a *ngIf="useLink"
    #actionMenuTrigger
    [matMenuTriggerFor]="actionMenu"
    (click)="$event.stopPropagation()">
    {{label | translate}}
</a>

<mat-menu #actionMenu="matMenu"
    [overlapTrigger]="false">
    <div style="display: flex;flex-direction: column;">
        <div *ngIf="showNoRowSelectedMsg" style="padding-left: 10px;padding-right: 10px;text-align: center;">
            <span style="color: #b71c1c;">
                At least one checkbox must be selected<br>in order to use these options.
            </span>
        </div>
        <div *ngFor="let item of topMenuItems; let i = index">
            <button mat-menu-item
                class="menuItem"
                *ngIf="item != 'mat-divider'"
                (click)="topMenuItemClicked(i)">
                <div>
                    <span [ngStyle]="{'color': this.isTopMenuItemDisabled(i) ? 'lightgray' : 'inherit'}"
                        translate>{{item}}</span>
                </div>
            </button>
            <mat-divider *ngIf="item == 'mat-divider'"></mat-divider>
        </div>
        <ng-content class="menuItem"></ng-content>
        <ng-container *ngFor="let item of complexMenuItems;">
            <ng-container *ngTemplateOutlet="menuItemTemplate; context: {item: item}"></ng-container>
        </ng-container>
        <div *ngFor="let item of bottomMenuItems; let i = index">
            <button mat-menu-item
                class="menuItem"
                *ngIf="item != 'mat-divider'"
                (click)="bottomMenuItemClicked(i)">
                <div>
                    <span [ngStyle]="{'color': this.isBottomMenuItemDisabled(i) ? 'lightgray' : 'inherit'}"
                        translate>{{item}}</span>
                </div>
            </button>
            <mat-divider *ngIf="item == 'mat-divider'"></mat-divider>
        </div>
    </div>
</mat-menu>

<!-- Menu Item Template -->
<ng-template #menuItemTemplate
    let-item="item"
    let-index="index">

    <!-- Menu Item -->
    <ng-container *ngIf="item != 'mat-divider'">

        <!-- Item with a submenu -->
        <button *ngIf="item.childItems && item.childItems.length > 0"
            mat-menu-item
            class="menuItem"
            style="align-items: center; display: flex;"
            [matMenuTriggerFor]="childActions"
            [disabled]="item.disabled"
            (click)="$event.stopPropagation();">
            <span>{{item.itemName | translate}}</span>
            &nbsp;
            <img src="./assets/images/menu pointer small black.png"
                style="width: 1em; height: 1em;">
            <mat-menu #childActions="matMenu"
                [overlapTrigger]="true">
                <div style="display: flex;flex-direction: column;">
                    <div *ngFor="let childItem of item.childItems">
                        <ng-container *ngTemplateOutlet="menuItemTemplate; context: {item: childItem}"></ng-container>
                    </div>
                </div>
            </mat-menu>
        </button>

        <!-- Item without submenu -->
        <button *ngIf="!item.childItems || item.childItems.length == 0"
            mat-menu-item
            class="menuItem"
            style="align-items: center; display: flex;"
            [disabled]="item.disabled"
            (click)="menuItemClicked(item);">
            <span>{{item.itemName | translate}}</span>
        </button>
    </ng-container>

    <!-- Divider -->
    <mat-divider *ngIf="item == 'mat-divider'"></mat-divider>
</ng-template>